import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'; // Using Heroicons for the menu icon

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false); // State to manage mobile menu visibility

  const linkClass = ({ isActive }) =>
    `px-3 py-2 rounded-md text-base font-medium transition-colors duration-200 ${
      isActive
        ? "bg-blue-600 text-white" // Active link style for mobile and desktop
        : "text-gray-300 hover:bg-gray-700 hover:text-white" // Inactive link style
    }`;

  const mobileLinkClass = ({ isActive }) =>
    `block px-3 py-2 rounded-md text-base font-medium transition-colors duration-200 ${
      isActive
        ? "bg-blue-600 text-white"
        : "text-gray-300 hover:bg-gray-700 hover:text-white"
    }`;

  return (
    <nav className="sticky top-0 z-50 p-4 text-white bg-gray-900 shadow-lg" style={{ fontFamily: 'Inter, sans-serif' }}>
      <div className="container flex items-center justify-between mx-auto">
        {/* Left side: Logo */}
        <NavLink to="/" className="m-0 text-3xl font-extrabold tracking-wide text-blue-400">
          Lumora
        </NavLink>

        {/* Right side: Nav links (Desktop) */}
        <div className="hidden space-x-6 md:flex">
          <NavLink to="/" className={linkClass}>Home</NavLink>
          <NavLink to="/about" className={linkClass}>About</NavLink>
          <NavLink to="/details" className={linkClass}>Celestial</NavLink>
          <NavLink to="/explore" className={linkClass}>Explore</NavLink>
          <NavLink to="/encyclopedia" className={linkClass}>Encyclopedia</NavLink>
          <NavLink to="/contact" className={linkClass}>Contact</NavLink>
        </div>

        {/* Mobile menu button */}
        <div className="flex items-center md:hidden">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="inline-flex items-center justify-center p-2 text-gray-400 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
          >
            <span className="sr-only">Open main menu</span>
            {isOpen ? (
              <XMarkIcon className="block w-6 h-6" aria-hidden="true" />
            ) : (
              <Bars3Icon className="block w-6 h-6" aria-hidden="true" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile menu items */}
      <div
        className={`md:hidden ${isOpen ? 'block' : 'hidden'} mt-4 space-y-2 px-2 pb-3`}
        // Optionally close menu when a link is clicked
        onClick={() => setIsOpen(false)}
      >
        <NavLink to="/" className={mobileLinkClass}>Home</NavLink>
        <NavLink to="/about" className={mobileLinkClass}>About</NavLink>
        <NavLink to="/details" className={mobileLinkClass}>Celestial</NavLink>
        <NavLink to="/explore" className={mobileLinkClass}>Explore</NavLink>
        <NavLink to="/contact" className={mobileLinkClass}>Contact</NavLink>
      </div>
    </nav>
  );
}